import React, { createContext, useContext, useMemo, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { LANGUAGES, t, getLang } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const { lang: paramLang } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const lang = LANGUAGES.find((l) => l.code === paramLang) ? paramLang : "en";
  const dir = getLang(lang).dir || "ltr";

  const tt = useCallback((key) => t(lang, key), [lang]);

  const setLang = useCallback(
    (code) => {
      const path = location.pathname.replace(/^\/[a-z]{2}/, `/${code}`);
      navigate(path + location.search);
    },
    [location, navigate]
  );

  const value = useMemo(() => ({ lang, dir, t: tt, setLang }), [lang, dir, tt, setLang]);

  return (
    <LanguageContext.Provider value={value}>
      <div dir={dir}>{children}</div>
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be inside LanguageProvider");
  return ctx;
}
